/**
 * @file
 */

import { hideFieldErrorPrompt } from "@/common/validation/utils.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializePaymentInstructionsPage() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   $("[id*='txtPaymentPercentage']").mask("9?99");

   $("[id*='txtPaymentPercentage']").blur(function (e) {
      setRunningPercentage();
   });

   $("[id*='txtPaymentPercentage']").click(function (e) {
      setRunningPercentage();
   });
   //  ----------------------------------------------------------------------------------------------------------------- 
   // only allow one checkbox to be checked at a time in the Single Loan repeater
   // The group of checkboxes behaving as a radio button list have the classname treatCBasRB2 to identify them.          
   //  ----------------------------------------------------------------------------------------------------------------- 
   $(".treatCBasRB input[type='checkbox']").click(function (e) {
      // -----------------------------
      // uncheck all the checkboxes
      // -----------------------------
      $(".treatCBasRB input[type='checkbox']").prop('checked', false);
      // ---------------------------------------------------------
      // check the checkbox that is associated with this event
      // ---------------------------------------------------------
      $(this).prop('checked', true);
   });

   //  ----------------------------------------------------------------------------------------------------------------- 
   // only allow one checkbox to be checked at a time in the Single Loan repeater
   // The group of checkboxes behaving as a radio button list have the classname treatCBasRB2 to identify them.          
   //  ----------------------------------------------------------------------------------------------------------------- 
   $(".treatCBasRB2 input[type='checkbox']").click(function (e)
   {
      // -----------------------------
      // uncheck all the checkboxes
      // -----------------------------
      $(".treatCBasRB2 input[type='checkbox']").prop('checked',false);
      // ---------------------------------------------------------
      // check the checkbox that is associated with this event
      // ---------------------------------------------------------
      $(this).prop('checked', true);
   });

   //  ----------------------------------------------------------------------------------------------------------------- 
   //  show or hide input areas based upon which payment selection checkbox is checked
   //  ----------------------------------------------------------------------------------------------------------------- 
   $(".useGrid input[type='checkbox']").click(function (e)
   {
      // -------------------------------------------------------
      // hide the grids for now. show it if a box gets checked
      // -------------------------------------------------------
      $(".loanLevelMultipleSection").toggleClass('ui-helper-hidden',true);   // hide the section
      $(".loanLevelSingleSection").toggleClass('ui-helper-hidden',true);     // hide the section
      $(".loanOtherSection").toggleClass('ui-helper-hidden',true);           // hide the section

      // -------------------------------------------------------
      // get id of checkbox that fired the event
      // and determine if grid needs to be shown
      // -------------------------------------------------------
      var eventTargetID = e.target.id;
      if (eventTargetID !== 'undefined') {
         if (eventTargetID.indexOf('chkSingle') !== -1) {
            if (this.checked) {
               if ($("[id$='hdnHasMultiple']").val() === "M") {
                  $(".loanLevelSingleSection").toggleClass('ui-helper-hidden',false);    // show the section
                  $("[id$='hdnSelectionChecked']").attr('value','S');
               }
            }
         }
         if (eventTargetID.indexOf('chkMultiple') !== -1) {
            if (this.checked) {
               if ($("[id$='hdnHasMultiple']").val() === "M") {
                  $(".loanLevelMultipleSection").toggleClass('ui-helper-hidden',false);  // show the section
                  $("[id$='hdnSelectionChecked']").attr('value','M');
               }
            }
         }
         if (eventTargetID.indexOf('chkOther') !== -1) {
            $(".loanOtherSection").toggleClass('ui-helper-hidden',false);                // show the section
            $("[id$='hdnSelectionChecked']").attr('value','O');
         }
         if (eventTargetID.indexOf('chkAll') !== -1) {
            $("[id$='hdnSelectionChecked']").attr('value','A');
         }
      }
   });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-09
  window.isPaymentInstructionsValid = isPaymentInstructionsValid;
};

function setRunningPercentage() {
   var percentageTotal = 0;
   var cbLoanLevel = $("[id*='chkMultiple']");

   if (cbLoanLevel.is(':checked')) {
      $("[id*='txtPaymentPercentage']").each(function () {
         var percentage = $(this).val();
         percentage = percentage.replace(/_/g, '');
         if (percentage != "") {
            percentage = Number(percentage)
            if (!isNaN(percentage)) {
               if ((percentageTotal + percentage) <= 100) {
                  percentageTotal = percentageTotal + percentage
                  hideFieldErrorPrompt('lblFuturePercentage');
               } else {
                  $("[id$='lblFuturePercentage']").validationEngine('showPrompt', 'The total percentage cannot be greater than 100%', 'error', 'topLeft', false);
               }
            }
         }
      });
      $("[id$='lblFuturePercentage']").text(percentageTotal);
   }
}

function isPaymentInstructionsValid() {
   var oneChecked = 0;
   var cbSingleLoanLevel = $("[id*='chkSingle']");
   var cbMultiLoanLevel = $("[id*='chkMultiple']");
   var cbOther = $("[id*='chkOther']");

   if (cbMultiLoanLevel.is(':checked')) {
      var lblFuturePercentage = $("[id$='lblFuturePercentage']");
      var futurePercentageString = lblFuturePercentage.text();
      var futurePercentage = parseInt(futurePercentageString);

      if (futurePercentage == 100) {
         return true;
      }
      lblFuturePercentage.validationEngine('showPrompt', 'The total percentage must be 100%', 'error', 'topLeft', false);
   } else {
      if (cbOther.is(':checked')) {
         var otherLength = $("[id$='txtOtherSection']").val().length;
         if (otherLength == 0) {
            var otherTextArea = $("[id$='lblOtherTextArea']");
            otherTextArea.validationEngine('showPrompt', 'Instructions must be entered before submitting request.', 'error', 'topLeft', false);
         } else {
            return true;
         }
      } else {
         if (cbSingleLoanLevel.is(':checked')) {
            $(".treatCBasRB2 input[type='checkbox']").each(function () {
               if (this.checked) {
                  oneChecked = 1;
               }
            });
            if (oneChecked == 1) {
               return true;
            }
            var lblSingleCheckBoxes = $("[id$='lblSingleCheckBoxes']");
            lblSingleCheckBoxes.validationEngine('showPrompt', 'One checkbox must be selected.', 'error', 'topLeft', false);
         } else {
            return true;
         }
      }
   }

   return false;
} 



